var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-check-container"},[_c('svg',{staticClass:"animated-check",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M4.1 12.7L9 17.6 20.3 6.3","fill":"none"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }